export interface PropertyStatus {
  id: number;
  name: string;
  color: string;
  label: string;
  value: number;
}
export interface I_PROPERTY_STATUS {
  [name: string]: PropertyStatus;
}

export const C_PROPERTIES_STATUS = {
  PRECAPTURED: {
    id: -5,
    name: "Precaptada",
    color: "#87CEEB",
    label: "Precaptada",
    value: "precaptured"
  },
  INNEGOTIATION: {
    id: -4,
    name: "En Negociación",
    color: "#BA55D3",
    label: "En Negociación",
    value: "innegotiation"
  },
  INCONFLICT: {
    id: -3,
    name: "En Conflicto",
    color: "#FFA500",
    label: "En Conflicto",
    value: "inconflict"
  },
  DROPPED: {
    id: -2,
    name: "De Baja",
    color: "#FF6347",
    label: "De Baja",
    value: "dropped"
  },
  PENDING: {
    id: -1,
    name: "Pendiente",
    color: "#FFFF00",
    label: "Pendiente",
    value: "pending"
  },
  ACTIVE: {
    id: 0,
    name: "Disponible",
    color: "#8CC63F",
    label: "Disponible",
    value: "active"
  },
  ERROR: {
    id: -11,
    name: "Error",
    color: "#D3D3D3",
    label: "Error",
    value: -11
  }
};

export const A_PROPERTIES_STATUS_ARRAY = [
  C_PROPERTIES_STATUS.ACTIVE,
  C_PROPERTIES_STATUS.INNEGOTIATION,
  C_PROPERTIES_STATUS.INCONFLICT,
  C_PROPERTIES_STATUS.DROPPED,
  C_PROPERTIES_STATUS.PENDING
];

export const PROPERTIES_STATUS_FOR_NAME = {
  [C_PROPERTIES_STATUS.ACTIVE.name]: C_PROPERTIES_STATUS.ACTIVE,
  [C_PROPERTIES_STATUS.INNEGOTIATION.name]: C_PROPERTIES_STATUS.INNEGOTIATION,
  [C_PROPERTIES_STATUS.INCONFLICT.name]: C_PROPERTIES_STATUS.INCONFLICT,
  [C_PROPERTIES_STATUS.DROPPED.name]: C_PROPERTIES_STATUS.DROPPED,
  [C_PROPERTIES_STATUS.PENDING.name]: C_PROPERTIES_STATUS.PENDING,
  [C_PROPERTIES_STATUS.PRECAPTURED.name]: C_PROPERTIES_STATUS.PRECAPTURED,
  ["En Negociaci\u00f3n"]: C_PROPERTIES_STATUS.INNEGOTIATION
};

export const PROPERTIES_STATUS_FOR_VALUE = {
  [C_PROPERTIES_STATUS.ACTIVE.value]: C_PROPERTIES_STATUS.ACTIVE,
  [C_PROPERTIES_STATUS.INNEGOTIATION.value]: C_PROPERTIES_STATUS.INNEGOTIATION,
  [C_PROPERTIES_STATUS.INCONFLICT.value]: C_PROPERTIES_STATUS.INCONFLICT,
  [C_PROPERTIES_STATUS.DROPPED.value]: C_PROPERTIES_STATUS.DROPPED,
  [C_PROPERTIES_STATUS.PENDING.value]: C_PROPERTIES_STATUS.PENDING,
  [C_PROPERTIES_STATUS.PRECAPTURED.value]: C_PROPERTIES_STATUS.PRECAPTURED
};

export const PROPERTIES_STATUS_FOR_LABEL = {
  [C_PROPERTIES_STATUS.ACTIVE.label]: C_PROPERTIES_STATUS.ACTIVE,
  [C_PROPERTIES_STATUS.INNEGOTIATION.label]: C_PROPERTIES_STATUS.INNEGOTIATION,
  ["En Negociaci\u00f3n"]: C_PROPERTIES_STATUS.INNEGOTIATION,
  [C_PROPERTIES_STATUS.INCONFLICT.label]: C_PROPERTIES_STATUS.INCONFLICT,
  [C_PROPERTIES_STATUS.DROPPED.label]: C_PROPERTIES_STATUS.DROPPED,
  [C_PROPERTIES_STATUS.PENDING.label]: C_PROPERTIES_STATUS.PENDING,
  [C_PROPERTIES_STATUS.PRECAPTURED.label]: C_PROPERTIES_STATUS.PRECAPTURED
};

export const PROPERTIES_STATUS_FOR_ID = {
  [C_PROPERTIES_STATUS.ACTIVE.id]: C_PROPERTIES_STATUS.ACTIVE,
  [C_PROPERTIES_STATUS.INNEGOTIATION.id]: C_PROPERTIES_STATUS.INNEGOTIATION,
  [C_PROPERTIES_STATUS.INCONFLICT.id]: C_PROPERTIES_STATUS.INCONFLICT,
  [C_PROPERTIES_STATUS.DROPPED.id]: C_PROPERTIES_STATUS.DROPPED,
  [C_PROPERTIES_STATUS.PENDING.id]: C_PROPERTIES_STATUS.PENDING,
  [C_PROPERTIES_STATUS.PRECAPTURED.id]: C_PROPERTIES_STATUS.PRECAPTURED
};
